var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "innerWrapper" }, [
      _c("h1", [_vm._v("Privacy Policy")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      This policy describes how Unifi Property Pty Ltd (ACN 638 376 977) (\n      "
        ),
        _c("i", [_vm._v("Unifi, we us ")]),
        _vm._v("or "),
        _c("i", [_vm._v("our")]),
        _vm._v(
          ") collects, manages, stores, uses and\n      discloses your personal information. It contains the broad privacy\n      framework within which we operate, and should be read in conjunction\n      with any:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("supplementary privacy policies; and")]),
        _vm._v(" "),
        _c("p", [_vm._v("implementation procedures,")])
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("that we introduce or vary from time to time.")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      If you do not agree with the terms of this policy, please do not provide\n      us with your personal information.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("DEFINITIONS")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      To explain some of the terminology which commonly appears in this\n      policy:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "wai" }, [_vm._v("Information and records")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      nformation and records may be in electronic or hard copy form. This\n      policy does not extend to information or records that are publicly\n      available, or that would constitute an “employee record” as defined by\n      the Privacy Act 1988 (Cth) ("
        ),
        _c("i", [_vm._v("Privacy Act")]),
        _vm._v(").\n    ")
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "wai" }, [_vm._v("Sensitive information")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Sensitive information is an important type of personal information\n      relating to your:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("biometrics;")]),
        _vm._v(" "),
        _c("p", [_vm._v("criminal record;")]),
        _vm._v(" "),
        _c("p", [_vm._v("genetics;")]),
        _vm._v(" "),
        _c("p", [_vm._v("health;")]),
        _vm._v(" "),
        _c("p", [_vm._v("membership of a political association;")]),
        _vm._v(" "),
        _c("p", [_vm._v("membership of a professional or trade association;")]),
        _vm._v(" "),
        _c("p", [_vm._v("membership of a trade union;")]),
        _vm._v(" "),
        _c("p", [_vm._v("philosophical beliefs;")]),
        _vm._v(" "),
        _c("p", [_vm._v("political opinions;")]),
        _vm._v(" "),
        _c("p", [_vm._v("racial or ethnic origin;")]),
        _vm._v(" "),
        _c("p", [_vm._v("religious beliefs or affiliations; or")]),
        _vm._v(" "),
        _c("p", [_vm._v("sexual orientation or practices.")])
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v("HOW DOES UNIFI COLLECT AND HOLD PERSONAL INFORMATION?")
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "We collect personal information in a number of ways, including:"
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        directly from you, via email, telephone, post, when you provide\n        details for our mailing lists, purchase our services, place a\n        reservation for available properties, participate in our promotions,\n        create a referral account for our website or when you join one of our\n        clubs or programs; and\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        from third parties to whom you make payments in connection with our\n        reservations or services, or to whom you provide personal details in\n        connection with the receipt of marketing materials. This includes\n        third parties who you authorise to provide us with personal\n        information.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("\n      Cookies ["),
        _c("span", { staticClass: "red" }, [
          _vm._v(
            "Website developer to review and confirm accuracy of description under\n        “Cookies” section]"
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Our website uses 'cookies' to improve your browser experience. Cookies\n      are small text files that are downloaded and stored onto your computer's\n      browser directory when you visit a particular website. By using our\n      website, you consent to our use of cookies.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Cookies are used to track the pages and services you visit on our\n      website and to ensure that you are able to move freely across our\n      website without the need to re-enter information that you have already\n      provided.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("We use cookies to collect information including:")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("your computer's IP address and other technical information;")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        the date and time at which you access our website and the duration of\n        your visit;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("the pages and content that you viewed during your visit; and")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("the type of browser you are using.")])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      It is possible to disable cookies by adjusting your Internet browser's\n      setting, such that it refuses cookies. However, our website may not\n      function correctly in the event that your browser refuses cookies. For\n      an optimal browsing experience, we recommend that you allow the use of\n      cookies.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "wai" }, [_vm._v("Personal information")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("We will only solicit and collect personal information if:")
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        it is reasonably necessary in order for us to provide our services and\n        conduct our functions and activities; or\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("we are permitted to do so by law.")])
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "wai" }, [_vm._v("Sensitive information")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("We will only solicit and collect sensitive information if:")
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        we have your consent, and it is reasonably necessary for us to collect\n        sensitive information to enable us to carry out relevant functions or\n        activities; or\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("we are permitted to do so by law.")])
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "WHAT TYPES OF PERSONAL INFORMATION DOES UNIFI COLLECT AND HOLD?"
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Depending upon how you interact with us, we may collect the following\n      types of personal information from you:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("your name, gender and date of birth;")]),
        _vm._v(" "),
        _c("p", [_vm._v("your email address;")]),
        _vm._v(" "),
        _c("p", [_vm._v("your occupation, job title and place of business;")]),
        _vm._v(" "),
        _c("p", [_vm._v("the technology you use to access our services;")]),
        _vm._v(" "),
        _c("p", [_vm._v("your residential and postal address;")]),
        _vm._v(" "),
        _c("p", [_vm._v("telephone numbers;")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("your company name and Australian Business Number; or")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("your superannuation fund details.")])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      You may refuse to provide personal information to us. However, if you\n      exercise this right of refusal, it may affect our ability to meet our\n      obligations to you or to a third-party agency.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      You may also deal with us anonymously or by using a pseudonym. However,\n      if you do so, we may be prevented from providing you with accurate or\n      useful information, and you may not be able to access our full range of\n      services.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n      WHY DOES UNIFI COLLECT, HOLD, USE AND DISCLOSE PERSONAL INFORMATION?\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We may collect, hold and use your personal information for a number of\n      reasons including:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        to provide information in relation to our services and available\n        properties marketed for sale by our related companies and business\n        associates, including those we consider may be of interest to you in\n        the future;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to administer and manage processes which are key to our operations,\n        such as processing reservations of available properties or orders for\n        our services;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to effect the collection of money that you owe to us and to support\n        auditing, compliance and other corporate governance functions;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to assess any application for employment during the recruitment\n        process;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("to assess your creditworthiness;")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to create an online referral account for you to access our website;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to determine your eligibility for certain types of goods or services\n        that may be of interest to you;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to answer your queries, provide you with information you may have\n        requested and generally conduct dealings with you; and\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("to comply with legislative or other legal requirements.")
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We may disclose your personal information for a number of reasons\n      including:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        to identify you and verify your age, identity and corporate\n        information;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        to provide our services to you, or the organisation that you\n        represent;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("to improve our website and the services that we provide;")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("to communicate with you; and")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        for other purposes which are related, or directly related (in the case\n        of sensitive information), to the purpose for which your information\n        was initially collected.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("We may disclose your personal information to:")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        our related parties, including Varo Property Services Pty Ltd ACN 606\n        239 641;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        other companies or individuals that assist us to provide our\n        reservations and other services, or to administer our internal\n        operations. This includes:\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        electronic transactions / payment service providers, to process\n        reservations and other orders for our services;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        online booking service providers, to process bookings for our\n        services;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        government authorities or other agencies where the disclosure is\n        required or authorised by law;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        anyone else to whom you authorise us to disclose your personal\n        information;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        prospective purchasers of all or some of our business or assets, in\n        the event of a merger, re-organisation or sale of our business or\n        assets;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        information technology / cloud service providers, such as persons who\n        develop any of the software used by our business; and\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "suojin" }, [
          _vm._v(
            "\n        external business advisors, such as auditors and lawyers.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      There are also a limited number of circumstances in which the Privacy\n      Act permits us to use or disclose your personal information, without\n      your consent. An example of this is where the use or disclosure is\n      necessary to prevent a serious and imminent threat to any person's life,\n      health or safety or a serious threat to public health or safety.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("USE OF THIRD PARTY SOFTWARE")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("\n      As at ["),
        _c("span", { staticClass: "red" }, [
          _vm._v("insert date that this privacy policy is uploaded for use")
        ]),
        _vm._v(
          "], our website uses the following services and technologies that are\n      supplied by third parties:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("\n        ["),
          _c("span", { staticClass: "red" }, [
            _vm._v(
              "list the names of known third party providers – eg. for electronic\n          payment gateways etc"
            )
          ]),
          _vm._v("]\n      ")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Google Drive")])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Your personal information may be collected directly by the third party\n      providers of the abovementioned services and technologies, when you\n      input personal information via our website. You should review the\n      privacy policies of third parties who provide those technologies, to\n      ensure that you are satisfied with the manner in which they collect,\n      manage, store, use and disclose your personal information. Except where\n      we state otherwise in this policy, those third parties' dealings in your\n      personal information are not subject to our control and we are not\n      sponsored, affiliated or associated with those providers.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("DIRECT MARKETING")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We may collect, store and use your personal information to market our\n      services to you, where you have provided your implied or express consent\n      for us to do so. Consent may be implied when you have placed a\n      reservation or purchased services from us, joined one of our clubs or\n      programs, entered into a promotion conducted by us, where you have\n      subscribed to receive information from us or where you have enquired\n      about services that we provide.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      You may always opt out of receiving marketing material by contacting our\n      Privacy Officer or using the method that is provided in any of our\n      electronic marketing communications to you.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We will not disclose your personal information to a third party for them\n      to market their products or services to you, without your consent.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("CROSS-BORDER DISCLOSURE OF PERSONAL INFORMATION")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Personal information submitted on this website will be stored on the\n      Cloud (that is, the internet). To assist Unifi to store and access your\n      personal information on the Cloud, Unifi may store your personal\n      information with, or allow it to be accessed by, overseas third parties\n      who provide:\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "num" }, [_vm._v("1.")]),
        _vm._v("software and maintenance services for the\n      Cloud;\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "num" }, [_vm._v("2.")]),
        _vm._v(
          "training services in connection with using\n      and accessing the Cloud; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "num" }, [_vm._v("3.")]),
        _vm._v(
          "infrastructure / hardware used to access the\n      Cloud.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      As those third parties are situated, and store content, offshore\n      (including in jurisdictions such as Belgium, Chile, Denmark, Finland,\n      Ireland, Netherlands, Singapore, Taiwan and the United States of\n      America), your personal information may be transmitted, disclosed,\n      stored or accessed to and from overseas jurisdictions.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      If you submit your personal information on this website, you are\n      consenting to the transmission, disclosure, storage and access of your\n      personal information by third parties in overseas jurisdictions. In that\n      respect, "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("APP 8")]),
        _vm._v(
          " which ordinarily obliges\n      Unifi to take reasonable steps to ensure that overseas recipients of\n      your personal information do not breach the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("APPs")]),
        _vm._v(" (except\n      "),
        _c("span", { staticClass: "souwai" }, [_vm._v("APP")]),
        _vm._v(" 1) will not apply.\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Please note that if any of those overseas recipients handle your\n      personal information in a manner which is inconsistent, or does not\n      comply, with the "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("APPs")]),
        _vm._v(":\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "num" }, [_vm._v("1.")]),
        _vm._v(
          "to the maximum extent permitted by law, Unifi\n      will not be accountable under the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("Privacy Act")]),
        _vm._v(
          " for any resulting loss or damage\n      that you may suffer;\n    "
        )
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "num" }, [_vm._v("2.")]),
        _vm._v(
          "to the maximum extent permitted by law, you\n      will not be able to seek redress against Unifi under the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("Privacy Act")]),
        _vm._v(";\n    ")
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("span", { staticClass: "num" }, [_vm._v("3.")]),
        _vm._v(
          "the overseas recipient may not be subject to\n      any privacy obligations at all, or to any principles similar to the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("APPs")]),
        _vm._v(";\n    ")
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "num" }, [_vm._v("4.")]),
        _vm._v(
          "you may not be able to seek redress against\n      the overseas recipient in their jurisdiction; and\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _c("span", { staticClass: "num" }, [_vm._v("5.")]),
        _vm._v(
          "in holding your personal information, the\n      overseas recipient may be subject to foreign laws which compel their\n      disclosure of your personal information to other parties, such as\n      overseas government authorities.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v("HOW DOES UNIFI HOLD AND SECURE YOUR PERSONAL INFORMATION?")
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We will take all reasonable steps to ensure the personal information we\n      collect, use, or disclose is accurate, up to date, complete and\n      relevant, having regard to the purpose of the collection, use or\n      disclosure. You should ensure that any personal information you provide\n      to us is both relevant and accurate.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We have in place user names, passwords and access restrictions that\n      provide electronic protection of personal information stored\n      electronically. There are inherent risks with the transmission of data\n      over the internet. Whilst reasonably appropriate security measures are\n      in place for the protection of your personal information, you must be\n      aware that no guarantee is made that your personal information is\n      completely secure.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We also secure hard copy personal information within buildings or other\n      storage facilities, by placing restrictions on access to those buildings\n      or facilities (for example, by locking the buildings and filing cabinets\n      in which the personal information is stored).\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      In the event of any unauthorised access and/or disclosure of your\n      personal information, we comply with our obligations under the Privacy\n      Act in dealing with any such unauthorised access and/or disclosure,\n      including any obligations which may arise in respect of eligible data\n      breaches within the meaning of the\n      "
        ),
        _c("span", { staticClass: "souwai" }, [_vm._v("Privacy Act")]),
        _vm._v(".\n    ")
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n      HOW CAN YOU ACCCESS AND SEEK CORRECTION OF YOUR PERSONAL INFORMATION?\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We will deal with your requests for access or correction of your\n      personal information, in accordance with this policy.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n      All requests must be made in writing, and in the appropriate form\n      specified by us from time to time. Within a reasonable timeframe after\n      receiving your application, we will take reasonable steps to inform you\n      of what personal information we hold.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We will ordinarily grant access to the personal information unless:\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n        giving access would have an unreasonable impact on the privacy of\n        other individuals;\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("the request for access is frivolous or vexatious;")]),
        _vm._v(" "),
        _c("p", [_vm._v("we are unable to verify your identity;")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        we are entitled to reject your access to the personal information\n        pursuant to any law; or\n      "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("the access would be unlawful.")])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      We reserve the right to charge a reasonable fee for providing access to\n      the personal information, but not for making the application or\n      correcting personal information held by us. We may withhold access to\n      the personal information until the fee is paid.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      If you are of the view that your personal information requires\n      correction, you should contact the Privacy Officer listed below.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("COMPLAINTS")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      If you believe that we have breached this policy, please contact our\n      Privacy Officer by email at team@unifiproperty.com or by mail to:\n      Privacy Officer, 54 Prospect Road, Prospect, South Australia 5082. We\n      take all complaints seriously and will respond to you within a\n      reasonable period of time, unless we consider your complaint to be\n      frivolous, vexatious or without legal or factual merit. If you are not\n      satisfied with the way in which we have handled your complaint, you can\n      make a complaint to the Australian Information Commissioner.\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("MORE INFORMATION")]),
      _vm._v(" "),
      _c("h2", { staticStyle: { "margin-bottom": "80px" } }, [
        _vm._v(
          "\n      If you have any questions or require further information please contact\n      our Privacy Officer by e-mail at team@unifiproperty.com\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53aae14c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53aae14c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/more/policy.vue
// module id = null
// module chunks = 